import { IAppState, TActions } from '../../../common/state';
import { jq } from '../../../json_query';

export function suburbanHouseTypeReducer(state: IAppState, action: TActions): IAppState {
  switch (action.type) {
    case 'filters/tags/TAG_REMOVED':
      if (action.tag.type === 'advanced-suburbanHouseType') {
        return {
          ...state,
          filters: {
            ...state.filters,
            jsonQuery: jq(state.filters.jsonQuery).unsetIsDacha(),
          },
        };
      }

      return state;

    default:
      return state;
  }
}
